import React, { createContext, useContext, useState, useEffect } from 'react';

export const COLOR_THEMES = [
  { id: 'ocean-blue', name: 'Ocean Blue', color: '#6366f1', accent: '#4287f5' },
  { id: 'emerald-green', name: 'Emerald Green', color: '#10b981', accent: '#10b981' },
  { id: 'royal-purple', name: 'Royal Purple', color: '#8b5cf6', accent: '#8b5cf6' },
  { id: 'teal', name: 'Teal', color: '#14b8a6', accent: '#14b8a6' },
  { id: 'slate', name: 'Slate', color: '#475569', accent: '#475569' },
  { id: 'burgundy', name: 'Burgundy', color: '#9f1239', accent: '#9f1239' }
];

const ThemeContext = createContext({
  theme: 'light',
  colorTheme: 'ocean-blue',
  toggleTheme: () => {},
  setTheme: () => {},
  setColorTheme: () => {},
  availableColorThemes: COLOR_THEMES
});

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(() => {
    return localStorage.getItem('lis_theme') || 'light';
  });

  const [colorTheme, setColorThemeState] = useState(() => {
    return localStorage.getItem('lis_color_theme') || 'ocean-blue';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('lis_theme', theme);
  }, [theme]);

  useEffect(() => {
    document.documentElement.setAttribute('data-color-theme', colorTheme);
    localStorage.setItem('lis_color_theme', colorTheme);
  }, [colorTheme]);

  const toggleTheme = () => {
    setThemeState((prev) => (prev === 'light' ? 'dark' : 'light'));
  };

  const setTheme = (newTheme) => {
    if (newTheme === 'light' || newTheme === 'dark') {
      setThemeState(newTheme);
    }
  };

  const setColorTheme = (newColorTheme) => {
    if (COLOR_THEMES.some((t) => t.id === newColorTheme)) {
      setColorThemeState(newColorTheme);
    }
  };

  return (
    <ThemeContext.Provider
      value={{
        theme,
        colorTheme,
        toggleTheme,
        setTheme,
        setColorTheme,
        availableColorThemes: COLOR_THEMES
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);

export default ThemeContext;
